import axios from 'axios';
import qs from 'qs'

axios.defaults.timeout = 5000;
// const apiUrl = process.env.NODE_ENV === "development"?"https://exam.e-stronger.com":"https://www.jspx0769.com";
const apiUrl = "https://www.jspx0769.com"
// axios.defaults.baseURL = "https://www.jspx0769.com"; //线上服务器
// axios.defaults.baseURL = "https://exam.e-stronger.com";//测试服务器
// axios.defaults.baseURL = process.env.NODE_ENV === "development"?"":apiUrl;// 正式服务器
axios.defaults.baseURL = apiUrl; // 测试服务器
// console.log(apiUrl)
//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = qs.stringify(config.data);
    let token = ""
    if(localStorage.token){
      token = JSON.parse(localStorage.token)
    }
  config.headers = {
    'Content-Type':'application/x-www-form-urlencoded',
    'token':token.token
  }
  // 如果是验证码登录接口,则删掉token
  if(config.url == "/api/student/get_sms_code"){
    delete config.headers.token
  }
  if(config.url.indexOf('uploads') != -1){
    delete config.headers.token
  }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    // store.commit('hideLoading')
    return response
}, err => {
    // store.commit('hideLoading')
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
            window.console.log('错误请求')
          break;
        case 401:
            window.console.log('未授权，请重新登录')
          break;
        case 403:
          window.console.log('拒绝访问')
          break;
        case 404:
          window.console.log('请求错误,未找到该资源')
          break;
        case 405:
          window.console.log('请求方法未允许')
          break;
        case 408:
          window.console.log('请求超时')
          break;
        case 500:
          window.console.log('服务器端出错')
          break;
        case 501:
          window.console.log('网络未实现')
          break;
        case 502:
          window.console.log('网络错误')
          break;
        case 503:
          window.console.log('服务不可用')
          break;
        case 504:
          window.console.log('网络超时')
          break;
        case 505:
          window.console.log('http版本不支持该请求')
          break;
        default:
          window.console.log(`连接错误${err.response.status}`)
      }
    } else {
      window.console.log('连接到服务器失败')
    }
    return Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params,
      responseType: 'blob'
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export function post(url,data = {}){
   return new Promise((resolve,reject) => {
     axios.post(url,data)
          .then(response => {
            resolve(response.data);
          },err => {
            reject(err)
          })
   })
 }
